'use client'

import { memo } from 'react'
import { Github, X } from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  NIN_GITHUB_URL,
  NIN_TELEGRAM_COMMUNITY_URL,
  NIN_TWITTER_URL,
} from '@/app/nin/_components/nin-org-links'

const SOCIAL_ICON_CLASS = 'h-4 w-4 shrink-0'

const socialLinkClass =
  'ninxl-theme-link inline-flex h-9 w-9 items-center justify-center rounded-md border border-[color:var(--ninxl-8bit-border)] bg-[color:var(--ninxl-theme-bg-frame)] shadow-[2px_2px_0_0_var(--ninxl-8bit-dim)] transition hover:translate-x-px hover:translate-y-px'

/** baby: Telegram brand mark: lucide does not ship this icon */
const TelegramIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden>
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
)

export const NinSocialIconLinks = memo(function NinSocialIconLinks({
  className,
  includeGithub = true,
}: {
  className?: string
  /** Hide GitHub when a separate GitHub CTA already sits beside these icons */
  includeGithub?: boolean
}) {
  return (
    <div className={cn('flex items-center gap-2', className)} aria-label="Follow NIN">
      {includeGithub ? (
        <a
          href={NIN_GITHUB_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={socialLinkClass}
          aria-label="NIN on GitHub"
        >
          <Github className={SOCIAL_ICON_CLASS} strokeWidth={1.75} />
        </a>
      ) : null}
      <a
        href={NIN_TWITTER_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={socialLinkClass}
        aria-label="Follow NIN on X"
      >
        <X className={SOCIAL_ICON_CLASS} strokeWidth={1.75} />
      </a>
      <a
        href={NIN_TELEGRAM_COMMUNITY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={socialLinkClass}
        aria-label="Telegram community help"
      >
        <TelegramIcon className={SOCIAL_ICON_CLASS} />
      </a>
    </div>
  )
})
